import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { Measurer, ShadowedPointSymbol, ShadowedPolySymbol } from "@evergis/react";
import { FlexSpan, IconButton } from "../../../ui";
import { MapTooltip } from "./styled";
import { useCurrentFeature, useMeasurer } from "../../../hooks";
const lengthSymbol = new ShadowedPolySymbol({
    strokeWidth: 2,
    shadowSize: 0,
    shadowColor: "rgb(157, 135, 241)",
    strokeColor: "rgb(157, 135, 241)",
    vertexShadowSize: 0,
    showVertex: true,
    enclose: false,
});
const areaSymbol = new ShadowedPolySymbol({
    strokeWidth: 2,
    shadowSize: 0,
    shadowColor: "rgb(157, 135, 241)",
    strokeColor: "rgb(157, 135, 241)",
    vertexShadowSize: 0,
    fillColor: "rgba(96, 81, 156, 0.2)",
    enclose: true,
    showVertex: true,
});
export const snapSymbol = new ShadowedPointSymbol({
    size: 10,
    strokeWidth: 2,
    shadowSize: 0,
    fillColor: "#ffffff",
    shadowColor: "rgb(157, 135, 241)",
    strokeColor: "rgb(157, 135, 241)",
});
export const MeasurerControl = () => {
    const [isActive, setIsActive] = useMeasurer();
    const [, setCurrentFeature] = useCurrentFeature();
    useEffect(() => {
        if (isActive) {
            setCurrentFeature(void 0);
        }
    }, [isActive, setCurrentFeature]);
    useEffect(() => {
        return () => {
            setIsActive(false);
        };
    }, []); // eslint-disable-line
    return (_jsxs(FlexSpan, { display: "flex", children: [_jsx(IconButton, { active: isActive, icon: "measurer", onClick: () => setIsActive(!isActive) }), _jsx(Measurer, { isActive: isActive, lengthSymbol: lengthSymbol, areaSymbol: areaSymbol, snapSymbol: snapSymbol, renderLabelSymbol: ({ content, onClose }) => (_jsxs(MapTooltip, { children: [content, onClose && (_jsx(IconButton, { icon: "close", onClick: event => {
                                event.stopPropagation();
                                onClose();
                            } }))] })) })] }));
};
